import React from 'react';

/**
 * This method is intended to be used any time a possible undefined context is
 * needed.
 *
 * If the context is not present it will throw an error, allowing typescript to
 * be sure about its existence in the following lines.
 */
export default function useContext<T>(
  which: React.Context<T> | React.Context<T | undefined>,
): NonNullable<T> {
  const context = React.useContext<T | undefined>(
    which as React.Context<T | undefined>,
  );
  if (!context)
    throw new Error(`There is no context ${which.displayName ?? 'Noname'}`);
  return context as NonNullable<T>;
}
